import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=1aa8318c&scoped=true"
import script from "./KPI.vue?vue&type=script&lang=js"
export * from "./KPI.vue?vue&type=script&lang=js"
import style0 from "./KPI.vue?vue&type=style&index=0&id=1aa8318c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8318c",
  null
  
)

export default component.exports